export const EXPLANATIONS = {
    LEVEL_1: {
        FIRST_NAME: "השם הפרטי כולל שם שני פרטי אם יש.",
        FAMILY_NAME: "שם המשפחה חיוני לחישוב מפת הנומרולוגיה.",
        MOTHER_NAME: "שם האם המדויק (כולל שם שני אם יש) חיוני לחישובים המבוססים על מסורת הקבלה.",
        BIRTH_DATE: "תאריך הלידה מהווה את הבסיס לחישוב המפה האסטרולוגית והנומרולוגית.",
        BIRTH_TIME: "זמן מדויק מאפשר מיקום כוכבים מדויק, וחשוב במיוחד קרוב למעברי כוכבים בין מזלות - המעבר חד ומיידי ויכול להשפיע על המפה הסימבולית.",
        LOCATION: "מיקומך הגאוגרפי משפיע על זווית הראייה של השמיים ברגע הלידה וכך גם על מצב הכוכבים המדויק בשבמים.",
        HEBREW_ONLY: "שיטת החישוב מבוססת על האותיות העבריות לחישוב מזל האור המקיף.",
    },
    LEVEL_2: {
        SHABTAI_WHY: "המערכת משתמשת באותיות העבריות לפי מסורת קבלית עתיקה לחישוב האור המקיף שלך.",
        LOCATION_PRECISION: "מיקום מדויק מאפשר לנו לחשב את הבתים האסטרולוגיים ואת האופק בדיוק של דקות, מה שמעניק רובד נוסף לניתוח התבניות.",
    },
    LEVEL_3: {
        MISSION: "Spirit Research Lab היא מערכת מחקר ומעקב אחרי נתונים אסטרולוגיים נומרולוגיים וקבליים. כאן תוכלו לשמור נתונים של אנשים שאתם מכירים, להצליב מפות, וללמוד אסטרולוגיה ונומרולוגיה מתוך הניסיון שלכם, ובלי מתווכים.",
    }
};
